import { ParseNode, } from '@mode-switch/express';
export var Pipeline;
(function (Pipeline) {
    function make() {
        return {
            paths: new Map(),
            params: new Map(),
            columns: new Map(),
            calcs: new Map(),
            dataTypes: new Map(),
            dataRoles: new Map(),
            callArgs: new Map(),
            exprCalls: new Map(),
            exprStages: new Map(),
            exprNodes: new Map(),
        };
    }
    Pipeline.make = make;
    let Paths;
    (function (Paths) {
        function get(pipeline, node) {
            return pipeline.paths.get(ParseNode.id(node));
        }
        Paths.get = get;
        function set(pipeline, node, path) {
            const paths = new Map(pipeline.paths);
            paths.set(ParseNode.id(node), path);
            return {
                ...pipeline,
                paths,
            };
        }
        Paths.set = set;
    })(Paths = Pipeline.Paths || (Pipeline.Paths = {}));
    let Params;
    (function (Params) {
        function get(pipeline, node) {
            return pipeline.params.get(ParseNode.id(node));
        }
        Params.get = get;
        function set(pipeline, node, param) {
            const params = new Map(pipeline.params);
            params.set(ParseNode.id(node), param);
            return {
                ...pipeline,
                params,
            };
        }
        Params.set = set;
    })(Params = Pipeline.Params || (Pipeline.Params = {}));
    let Columns;
    (function (Columns) {
        function get(pipeline, node) {
            return pipeline.columns.get(ParseNode.id(node));
        }
        Columns.get = get;
        function set(pipeline, node, column) {
            const columns = new Map(pipeline.columns);
            columns.set(ParseNode.id(node), column);
            return {
                ...pipeline,
                columns,
            };
        }
        Columns.set = set;
    })(Columns = Pipeline.Columns || (Pipeline.Columns = {}));
    let Calcs;
    (function (Calcs) {
        function get(pipeline, node) {
            return pipeline.calcs.get(ParseNode.id(node));
        }
        Calcs.get = get;
        function set(pipeline, node, calc) {
            const calcs = new Map(pipeline.calcs);
            calcs.set(ParseNode.id(node), calc);
            return {
                ...pipeline,
                calcs,
            };
        }
        Calcs.set = set;
    })(Calcs = Pipeline.Calcs || (Pipeline.Calcs = {}));
    let CallArgs;
    (function (CallArgs) {
        function get(pipeline, node) {
            var _a;
            return (_a = pipeline.callArgs.get(ParseNode.id(node))) !== null && _a !== void 0 ? _a : [];
        }
        CallArgs.get = get;
        function set(pipeline, node, args) {
            const exprArgs = new Map(pipeline.callArgs);
            exprArgs.set(ParseNode.id(node), args);
            return {
                ...pipeline,
                callArgs: exprArgs,
            };
        }
        CallArgs.set = set;
    })(CallArgs = Pipeline.CallArgs || (Pipeline.CallArgs = {}));
    let ExprCalls;
    (function (ExprCalls) {
        function get(pipeline, node) {
            return pipeline.exprCalls.get(ParseNode.id(node));
        }
        ExprCalls.get = get;
        function set(pipeline, node, call) {
            const exprCalls = new Map(pipeline.exprCalls);
            exprCalls.set(ParseNode.id(node), call);
            return {
                ...pipeline,
                exprCalls,
            };
        }
        ExprCalls.set = set;
    })(ExprCalls = Pipeline.ExprCalls || (Pipeline.ExprCalls = {}));
    let DataTypes;
    (function (DataTypes) {
        function get(pipeline, node) {
            return pipeline.dataTypes.get(ParseNode.id(node));
        }
        DataTypes.get = get;
        function set(pipeline, node, type) {
            const dataTypes = new Map(pipeline.dataTypes);
            dataTypes.set(ParseNode.id(node), type);
            return {
                ...pipeline,
                dataTypes,
            };
        }
        DataTypes.set = set;
    })(DataTypes = Pipeline.DataTypes || (Pipeline.DataTypes = {}));
    let DataRoles;
    (function (DataRoles) {
        function get(pipeline, node) {
            return pipeline.dataRoles.get(ParseNode.id(node));
        }
        DataRoles.get = get;
        function set(pipeline, node, role) {
            const dataRoles = new Map(pipeline.dataRoles);
            dataRoles.set(ParseNode.id(node), role);
            return {
                ...pipeline,
                dataRoles,
            };
        }
        DataRoles.set = set;
    })(DataRoles = Pipeline.DataRoles || (Pipeline.DataRoles = {}));
    let ExprStages;
    (function (ExprStages) {
        function get(pipeline, node) {
            return pipeline.exprStages.get(ParseNode.id(node));
        }
        ExprStages.get = get;
        function set(pipeline, node, stage) {
            const exprStages = new Map(pipeline.exprStages);
            exprStages.set(ParseNode.id(node), stage);
            return {
                ...pipeline,
                exprStages,
            };
        }
        ExprStages.set = set;
    })(ExprStages = Pipeline.ExprStages || (Pipeline.ExprStages = {}));
    let ExprNodes;
    (function (ExprNodes) {
        function get(pipeline, node) {
            return pipeline.exprNodes.get(ParseNode.id(node));
        }
        ExprNodes.get = get;
        function set(pipeline, node, expr) {
            const exprNodes = new Map(pipeline.exprNodes);
            exprNodes.set(ParseNode.id(node), expr);
            return {
                ...pipeline,
                exprNodes,
            };
        }
        ExprNodes.set = set;
    })(ExprNodes = Pipeline.ExprNodes || (Pipeline.ExprNodes = {}));
})(Pipeline || (Pipeline = {}));
